/* ==========================================================================
   The WHYTE Ritual 
   ========================================================================== */
(function () {
  "use strict";

  /* ----------------------------------------------------------------------
     Marquee — clones the markup group once so the loop is seamless
     ---------------------------------------------------------------------- */
  function initMarquees() {
    var tracks = document.querySelectorAll("[data-marquee]");
    Array.prototype.forEach.call(tracks, function (track) {
      var group = track.querySelector(".wr-marquee__group");
      if (!group) return;
      var clone = group.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
    });
  }

  /* ----------------------------------------------------------------------
     FAQ accordion — open state is declared in the HTML (class "is-open")
     ---------------------------------------------------------------------- */
  function setOpen(item, panel, button, open) {
    item.classList.toggle("is-open", open);
    button.setAttribute("aria-expanded", open ? "true" : "false");
    panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
  }

  function initFaq() {
    var container = document.querySelector("[data-faq]");
    if (!container) return;

    var entries = [];
    var items = container.querySelectorAll(".wr-faq__item");

    Array.prototype.forEach.call(items, function (item) {
      var button = item.querySelector(".wr-faq__question");
      var panel = item.querySelector(".wr-faq__answer");
      if (!button || !panel) return;

      var entry = { item: item, button: button, panel: panel };
      entries.push(entry);

      setOpen(item, panel, button, item.classList.contains("is-open"));

      button.addEventListener("click", function () {
        var willOpen = !item.classList.contains("is-open");
        entries.forEach(function (other) {
          setOpen(other.item, other.panel, other.button, false);
        });
        if (willOpen) setOpen(item, panel, button, true);
      });
    });

    window.addEventListener("resize", function () {
      entries.forEach(function (entry) {
        if (entry.item.classList.contains("is-open")) {
          entry.panel.style.maxHeight = entry.panel.scrollHeight + "px";
        }
      });
    });
  }

  /* ----------------------------------------------------------------------
     Scroll reveal
     ---------------------------------------------------------------------- */
  function initReveal() {
    var nodes = document.querySelectorAll("[data-reveal]");
    if (!nodes.length) return;

    if (typeof IntersectionObserver === "undefined") {
      Array.prototype.forEach.call(nodes, function (node) {
        node.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0.12 },
    );

    Array.prototype.forEach.call(nodes, function (node) {
      observer.observe(node);
    });
  }

  /* ----------------------------------------------------------------------
     Button press feedback + smooth anchor scrolling
     ---------------------------------------------------------------------- */
  function initButtons() {
    var buttons = document.querySelectorAll(".wr-btn");
    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener("pointerdown", function () {
        button.classList.add("is-pressed");
      });
      ["pointerup", "pointerleave", "pointercancel"].forEach(function (evt) {
        button.addEventListener(evt, function () {
          button.classList.remove("is-pressed");
        });
      });

      button.addEventListener("click", function (event) {
        var href = button.getAttribute("href") || "";
        if (href.charAt(0) !== "#" || href.length < 2) return;
        var target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function init() {
    initMarquees();
    initFaq();
    initButtons();
    initReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
